/**
 * Set Password page - same layout as Login/Signup (header, main, footer).
 */

import React from 'react';
import SetPasswordComponent from '../../components/auth/SetPassword';
import { PublicHeader, PublicFooter } from '../../components/public';

const SetPassword = () => (
  <div className="auth-page-layout">
    <PublicHeader />
    <main className="auth-page-main">
      <SetPasswordComponent />
    </main>
    <PublicFooter />
  </div>
);

export default SetPassword;
